import { Component, OnInit } from '@angular/core'
import { UrlSerializer } from '@angular/router'
import { Location } from '@angular/common'
import { GoogleTagManagerService } from './google-tag-manager.service'
import { EnvironmentService } from './environment.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private _urlSerializer: UrlSerializer,
    private _location: Location,
    private _googleTagManagerService: GoogleTagManagerService,
    private _environmentService: EnvironmentService
  ) {
  }

  public ngOnInit() {
    this._replaceRewrittenHashRoute(this._urlSerializer.parse(this._location.path(true)).fragment, this._location)
    this._installGoogleTagManager()
  }

  private _installGoogleTagManager() {
    this._googleTagManagerService.install(this._environmentService.get('KAP_GTM_ID'))
  }

  private _replaceRewrittenHashRoute(currentHashFragment: string, location: Location) {
    if (
      typeof currentHashFragment === 'string'
      && currentHashFragment.length > 0
      && currentHashFragment.startsWith('/')
    ) {

      const fragment = !this._environmentService.get('production') ? location.path(true).replace('#', '') : currentHashFragment
      // removing trailing slash in route that will have been added in routing layer
      location.replaceState(fragment.replace(/\/($|\?)/, '$1'))
    }
  }
}
